/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Popover, Select } from "antd";
import * as moment from "moment";
import { InfoCircleOutlined } from '@ant-design/icons';

import patientIcon from "../../../assets/images/Patient.svg";

class ViewCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  renderTime(date) {
    return moment(date).format("h:mm A");
  }

  renderDate(date) {
    return moment(date).format("MMM Do, YY");
  }

  cIncOut = () => {
    let item = this.props.item;
    let { queue_type } = this.props.queueitem;
    let QType = this.props.queueitem && queue_type;
    return (
      <>
        {item.status === "3" ? (
          <p className="text-dark">C-IN</p>
        ) : item.status === "4" ? (
          <p className="text-dark">C-OUT</p>
        ) : (
          ""
        )}
      </>
    );
  };

  render() {
    let item = this.props.item;
    let queueitemlength;
    if (
      this.props.queueitem.patients !== undefined &&
      this.props.queueitem.patients !== null
    ) {
      queueitemlength = this.props.queueitem.patients.length;
    }
    let QType = this.props.queueitem && this.props.queueitem.queue_type;

    const patient_details = (
      <div>
        <p className="mb-0">
          Service Group :{"\u00a0"}{" "}
          {item.bill_service_group ? item.bill_service_group : "--"}
        </p>
        <p className="mb-0">
          Service : {item.service_name ? item.service_name : "--"}
        </p>
        <p className="mb-0">
          Mobile No : {item.phonenumber ? item.phonenumber : "--"}
        </p>
        <p className="mb-0 text-capitalize">
          Emergency : {item.is_emergency ? item.is_emergency : "--"}
        </p>
        <p className="mb-0 text-capitalize">
          Bill Cancelled :{"\u00a0"}{" "}
          {item.bill_cancel_status ? item.bill_cancel_status : "No"}
        </p>
        {QType === "OPD Consultation" && (
          <>
            <p className="mb-0">
              Vitals Required :{"\u00a0"}{" "}
              {item.is_vitals_require !== null ? item.is_vitals_require : "--"}
            </p>
            <p className="mb-0">
              Vitals Status :{"\u00a0"}{" "}
              {item.is_vitals_require === "YES"
                ? item.is_vitals_done !== null
                  ? item.is_vitals_done === "YES"
                    ? "Done"
                    : "Not yet done"
                  : "Patient in Vitals Queue"
                : "--"}
            </p>
          </>
        )}
      </div>
    );
    let redLabel = false;

    return (
      <div
      
        className={`pr-0 pl-3 pt-1 disable-text ${
          redLabel ? "time-exceed" : ""
        } ${item.checkinskip == "1" ? "skipcolor" : ""}`}
      >
        {/* <div className="PatientCard mr-1 pb-2 h-auto"> */}
        <div className={item.checkout_time != null ? 'PatientCard mr-1 pb-2 h-auto que-completed-patients' : 'PatientCard mr-1 pb-2 h-auto'}>
          <div className="col pl-0">
            {QType === "OPD Consultation" && (
              <>
                <div className="row">
                  <div className="col-8">
                    {item.is_investigation && (
                      <small className="text-danger ml-2">Investigation</small>
                    )}
                  </div>
                </div>
              </>
            )}

            <div
              className={`row ${
                QType === "OPD Consultation" && !item.is_investigation && "mt-2"
              }`}
            >
              <div className="col-8 pr-0 pl-4">
                <img
                  alt=""
                  src={patientIcon}
                  className="patientIcon ml-0"
                  draggable={false}
                />
                <span className="Patientname text-wrap">
                  {item.name ? item.name : ""}
                </span>
              </div>
              <div className="col-4 pr-1 text-left">
                <span className="Patientname align-bottom">
                  <b>WT:</b> {item.waitingTAT}
                </span>
              </div>
            </div>

            <div className="row pl-2">
              <div className="col-8">
                <Popover
                  overlayClassName="popover-custom"
                  content={patient_details}
                  title=""
                >
                  {/* <Icon
                    type="info-circle"
                    style={{ color: "#ac7ab0" }}
                    className="uidIcon"
                  /> */}
                  <InfoCircleOutlined
  style={{ color: "#ac7ab0" }}
  className="uidIcon"
/>
                </Popover>
                <span className="PatientUid align-middle">
                  {item.umr ? item.umr : ""}
                </span>
              </div>
              <div className="col-4 ml-0">
                <span class="time m-auto">
                  {item.appointment_date && <span className="Patientname align-bottom ml-0">
                    <b>Apt:</b>
                    {"\u00a0"}{" "}
                    {this.renderTime(item.appointment_date) !== "Invalid date"
                      ? this.renderTime(item.appointment_date)
                      : ""}
                  </span>}
                </span>
              </div>
            </div>
            <div className="row pl-2">
              <div className="col-4">
                {item.arrivaltime &&<span className="Patientname align-bottom">
                  <b>Arr:</b>
                  {"\u00a0"}
                  {this.renderTime(item.arrivaltime) !== "Invalid date"
                    ? this.renderTime(item.arrivaltime)
                    : ""}
                </span>}
              </div>
              <div className="col-4 text-center">
                {item.checkin_time && <span className="Patientname align-bottom">
                  <b>CI:</b>
                  {"\u00a0"}
                  {this.renderTime(item.checkin_time) !== "Invalid date"
                    ? this.renderTime(item.checkin_time)
                    : ""}
                </span>}
              </div>
              <div className="col-4">
                {item.checkout_time && <span className="Patientname align-bottom ml-0">
                  <b>CO:</b>
                  {"\u00a0"}
                  {this.renderTime(item.checkout_time) !== "Invalid date"
                    ? this.renderTime(item.checkout_time)
                    : ""}
                </span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewCard;
